import Dexie from 'dexie';

export class NGODatabase extends Dexie {
  constructor() {
    super('NGOSurveyorDB');

    this.version(22).stores({
      forms: 'id, title, name, status, created_at, updated_at',
      submissions: 'id, form_id, submittedAt, syncStatus, created_at, latitude, longitude',
      form_questions: 'id, form_id, section_id, name, type, order',
      form_responses: 'id, submission_id, question_id, value',
      file_uploads: '++id, submission_id, field_id, field_type, sync_status, created_at',
      outbox: '++id, timestamp, type, tempId',
      settings: 'key',
      userProfile: '&id',
      organization: '&id, name, logo_blob',
      submissionMeta: 'form_id, lastFetchHadData, lastFetchTime',
      entities: 'id, entity_type_id, syncStatus, created_at',
      entity_types: 'id, name'
    }).upgrade(trans => {
    });

    this.forms = this.table('forms');
    this.submissions = this.table('submissions');
    this.form_questions = this.table('form_questions');
    this.form_responses = this.table('form_responses');
    this.file_uploads = this.table('file_uploads');
    this.outbox = this.table('outbox');
    this.settings = this.table('settings');
    this.userProfile = this.table('userProfile');
    this.organization = this.table('organization');
    this.submissionMeta = this.table('submissionMeta');
    this.entities = this.table('entities');
    this.entity_types = this.table('entity_types');
  }
}

export const db = new NGODatabase();

export const outboxOperations = {
  add(endpoint, method, payload) {
    return db.outbox.add({
      endpoint,
      method,
      payload,
      timestamp: new Date(),
      retryCount: 0,
    });
  },

  getAll() {
    return db.outbox.orderBy('timestamp').toArray();
  },

  delete(id) {
    return db.outbox.delete(id);
  },

  incrementRetry(id) {
    return db.outbox.where('id').equals(id).modify(item => {
      item.retryCount = (item.retryCount || 0) + 1;
    });
  },
};